import { z } from 'zod';
import { optionSchema } from '~/features/types';
import { PeerReference } from '~/types';
import { Events } from './events';

export type PeerRefSortOptions = 'lastName' | 'referenceDate' | 'requestDate' | 'id';

export type PeerRefSort = {
  sortBy: PeerRefSortOptions;
  lastName: number;
  id: number;
  referenceDate: number;
  requestDate: number;
  page: number;
  pageSize: number;
};

export interface CreateRefColumnsProps {
  handleDownload: (id: number, rowIdx: number) => void;
  handleDelete: (id: number, rowIdx: number) => void;
  // [MCV-1838] Re-send a still-pending request. `email` is for the confirmation text.
  handleResend: (id: number, email: string) => void;
  // True while a resend is in flight, so the button cannot fire twice.
  resendDisabled?: boolean;
}

// [MCV-1814] The pending request a duplicate send collided with.
export type PendingRef = { id: number; email: string };

export type Context = {
  loading: boolean;
  modal: boolean;
  peerRefs: PeerReference[];
  providerId: number;
  sort: PeerRefSort;
  // Optional so a context built without them stays valid.
  requestEmail?: string;
  pendingRef?: PendingRef | null;
};

export interface Scope {
  context: Context;
  event: Events;
}

export const peerReqSchema = z.object({
  firstName: z.string().min(3, { message: 'First name is required' }),
  lastName: z.string().min(3, { message: 'Last name is required' }),
  emailAddress: z.email(),
  phoneNum: z.string(),
  relationshipType: optionSchema,
});

export type PeerRequestFormValues = z.infer<typeof peerReqSchema>;
